import {Component} from '@angular/core';
import {NgbDatepickerMonthView} from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-month-view';
import {NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'custom-datepicker-month-view',
  templateUrl: './custom-datepicker-month.component.html',
  styleUrls: ['./custom-datepicker-month.component.scss']
})
export class CustomDatepickerMonthComponent extends NgbDatepickerMonthView {
  constructor(i18n: NgbDatepickerI18n) {
    super(i18n);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker-month.component.ts